import Service from "@ember/service";

interface NetworkInformation extends EventTarget {
  effectiveType?: "slow-2g" | "2g" | "3g" | "4g";
  type?:
    | "bluetooth"
    | "cellular"
    | "ethernet"
    | "none"
    | "wifi"
    | "wimax"
    | "other"
    | "unknown";
  downlink?: number;
  rtt?: number;
  saveData?: boolean;
}

interface NavigatorWithConnection extends Navigator {
  connection?: NetworkInformation;
  mozConnection?: NetworkInformation;
  webkitConnection?: NetworkInformation;
}

export default class NetworkDetectorService extends Service {
  detectConnection() {
    const networkInfo = this.getNetworkInfoAPI();
    if (networkInfo) {
      return { ...networkInfo, method: "network-api", reliable: true };
    }

    return {
      estimatedType: null,
      method: null
    };
  }

  getNetworkInfoAPI() {
    const nav = navigator as NavigatorWithConnection;
    const connection =
      nav.connection || nav.mozConnection || nav.webkitConnection;

    if (connection && connection.effectiveType) {
      return {
        effectiveType: connection.effectiveType,
        type: connection.type,
        downlink: connection.downlink,
        rtt: connection.rtt
      };
    }
    return null;
  }
}
